import React from 'react';
import {
  Filter,
  Filter2,
  Filter3,
  Filter4,
  Filter5,
  Filter6,
  Filter7,
  Filter8,
  Filter9,
  Filter9Plus,
} from '@material-ui/icons';


const icons = {
  0: Filter,
  1: Filter,
  2: Filter2,
  3: Filter3,
  4: Filter4,
  5: Filter5,
  6: Filter6,
  7: Filter7,
  8: Filter8,
  9: Filter9,
};


const SharedGalleryCountIcon = ({ count }) => {
  const Icon = icons[count] || Filter9Plus;

  return <Icon />;
};

export default SharedGalleryCountIcon;
